import { defineComponent as _defineComponent } from 'vue'
import { FeatureTypes } from '@/components/Billing/billing-types';
import { WORKFLOW_CAPABILITIES_MAP } from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/capabilities-consts';

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkflowCapabilityDescription',
  props: {
    capability: null
  },
  setup(__props: any) {

// @ts-ignore


return { __sfc: true,WORKFLOW_CAPABILITIES_MAP }
}

})